/**
 * Created by vladislav on 08.10.2019
 */

const RewardsListComponent = cc.Node.extend({
    ctor: function (reward, options) {
        this._super();

        this.reward = reward instanceof RewardsList ? reward : new RewardsList(reward, options);
        this.options = options || {};

        this.createContent();
        if (!this.options.noShowControls) {
            cleverapps.focusManager.showControlsWhileFocused(this.reward.listControls());
        }

        if (cleverapps.config.debugMode) {
            this.addPriceLabel();
        }
    },

    addPriceLabel: function () {
        cleverapps.UI.applyHover(this, {
            interactiveScale: false,
            onMouseOver: this.showPrice.bind(this),
            onMouseOut: this.hidePrice.bind(this)
        });
    },

    showPrice: function () {
        if (!cleverapps.flags.rewardsPrice) {
            return;
        }

        const styles = cleverapps.styles.RewardsListComponent.price;
        const cost = this.reward.calcCostByKind();
        const usd = (hard) => `$${(hard * Product.HARD_TO_USD).toFixed(2)}`;

        const currency = cleverapps.UI.generateOnlyText(usd(cost.currency), cleverapps.styles.FONTS.REWARDS_PRICE_CURRENCY_TEXT);
        const items = cleverapps.UI.generateOnlyText(` + ${usd(cost.items)}`, cleverapps.styles.FONTS.REWARDS_PRICE_TEXT);
        const lines = [new cleverapps.Layout([currency, items], { direction: cleverapps.UI.HORIZONTAL })];
        if (cost.unpriced.length) {
            lines.push(cleverapps.UI.generateOnlyText(`No price: ${cost.unpriced.join(", ")}`, cleverapps.styles.FONTS.REWARDS_PRICE_TEXT));
        }

        const label = this.price = new cleverapps.Layout(lines, { direction: cleverapps.UI.VERTICAL });
        label.setPosition(this.width / 2, this.height + styles.dy + label.height / 2);
        this.addChild(label);
    },

    hidePrice: function () {
        if (this.price) {
            this.price.removeFromParent();
            this.price = undefined;
        }
    },

    createContent: function () {
        const styles = cleverapps.styles.RewardsListComponent;
        const rewards = this.options.filterCustomAnimation ? this.reward.commonRewards : this.reward.listRewards();
        if (this.options.fitToBox && this.options.small === undefined) {
            this.autoIconSize();
        }

        const visibleRewards = rewards.filter((reward) => reward.getAmount() && !RewardTypes[reward.type].invisible);
        const icons = visibleRewards.map((reward) => this.createIcon(reward));
        this.iconHeight = Math.max(0, ...icons.map((icon) => icon.height * icon.scaleY));

        const targets = this.targets = visibleRewards.map((reward, index) => this.createOneReward(reward, icons[index]));

        this.content = new cleverapps.WrapGridLayout(targets, {
            reverseRows: this.options.reverseRows,
            columns: this.options.columns || this.calcColumnsCount(targets.length),
            fitToBox: this.options.fitToBox,
            separator: this.options.separator,
            margin: {
                x: this.options.margin && this.options.margin.x !== undefined ? this.options.margin.x : styles.margin.x,
                y: this.options.margin && this.options.margin.y !== undefined ? this.options.margin.y : styles.margin.y
            }
        });

        this.addChild(this.content);
        this.setContentSize2(this.content.width * this.content.scale, this.content.height * this.content.scaleY);
        this.setAnchorPoint(0.5, 0.5);
        this.content.setAnchorPoint(0.5, 0.5);
        this.content.setAlignment(this.width / 2, this.height / 2);
    },

    getTargets: function () {
        return this.targets;
    },

    fitToBox: function (box) {
        cleverapps.UI.fitToBox(this.content, box);
    },

    autoIconSize: function () {
        const area = this.options.fitToBox.width * this.options.fitToBox.height;
        const rewards = this.options.filterCustomAnimation ? this.reward.commonRewards : this.reward.listRewards();

        const smallArea = rewards.reduce((area, reward) => {
            if (reward.getAmount()) {
                const node = reward.getSmallIcon();
                this.addChild(node);
                node.removeFromParent();

                const contentSize = node.getContentSize();
                area += contentSize.width * contentSize.height;
            }
            return area;
        }, 0);

        this.options.small = smallArea && area / smallArea <= 1.5;
    },

    createIcon: function (reward) {
        const icon = this.options.small ? reward.getSmallIcon() : reward.getIcon();
        const wrap = this.options.iconWrap || {};

        cleverapps.UI.fitToBox(icon, {
            width: wrap.fixedSize ? wrap.width : undefined,
            height: wrap.height,
            maxScale: icon.scale
        });

        return icon;
    },

    createIconWrap: function (icon) {
        const wrap = this.options.iconWrap || {};

        const iconWrap = new cc.Node();
        iconWrap.setAnchorPoint(0.5, 0.5);

        const width = wrap.fixedSize
            ? (wrap.width || icon.width * icon.scale)
            : Math.max(wrap.width || 0, icon.width * icon.scale);
        iconWrap.setContentSize(width, wrap.height || this.iconHeight);

        iconWrap.addChild(icon);
        icon.setAlignment({ align: "center" }, { align: "center" });

        return iconWrap;
    },

    createOneReward: function (reward, icon) {
        const styles = cleverapps.styles.RewardsListComponent;

        let prefix = this.options.noPrefix ? "" : RewardType.DEFAULT_PREFIX;
        if (this.options.prefix) {
            prefix = this.options.prefix;
        }

        let text = reward.getText(prefix);
        if (this.options.hideTextForSingleReward && reward.getAmount() === 1) {
            text = "";
        }
        // eslint-disable-next-line no-restricted-syntax
        const textNode = cleverapps.UI.generateTTFText(text, this.options.font || cleverapps.styles.FONTS.REWARDS_LIST_TEXT || cleverapps.styles.FONTS.WINDOW_TEXT);

        const iconWrap = this.createIconWrap(icon);
        let iconBg;
        let textWrap;
        let textBg;

        if (this.options.iconBg) {
            iconBg = cleverapps.UI.createScale9Sprite(this.options.iconBg.image, cleverapps.UI.Scale9Rect.TwoPixelXY);
            if (this.options.iconBg.size) {
                iconBg.setContentSize2(this.options.iconBg.size);
            }
            let position = { x: { align: "center" }, y: { align: "center" } };
            if (this.options.iconBg.iconPosition) {
                position = this.options.iconBg.iconPosition;
            }
            iconWrap.setAlignment(position);
            iconBg.addChild(iconWrap);
        }

        if (this.options.textWrap) {
            textWrap = new cc.Node();
            textWrap.setAnchorPoint(0.5, 0.5);
            textWrap.setContentSize(this.options.textWrap);

            textWrap.addChild(textNode);

            textNode.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            textNode.setDimensions(textWrap.width, textWrap.height);

            textNode.setAlignment({ align: this.options.textWrap.alignX || "center" }, { align: "center" });
        }

        if (this.options.textBg) {
            textBg = cleverapps.UI.createScale9Sprite(this.options.textBg.image, cleverapps.UI.Scale9Rect.TwoPixelXY);
            if (this.options.textBgPadding) {
                // grow the bg around whatever it holds, so amounts of different width keep the
                // same gap to the border instead of sharing one fixed box
                const content = textWrap || textNode;
                const padding = cc.padding(this.options.textBgPadding);
                textBg.setContentSize2(
                    content.width + padding.left + padding.right,
                    content.height + padding.top + padding.bottom
                );
            } else if (this.options.textBg.size) {
                textBg.setContentSize2(this.options.textBg.size);
            }
            let position = { x: { align: "center" }, y: { align: "center" } };
            if (this.options.textBgPosition) {
                position = this.options.textBgPosition;
            }
            (textWrap || textNode).setAlignment(position);
            textBg.addChild((textWrap || textNode));
        }

        let target;

        if (this.options.textPosition) {
            target = cleverapps.UI.wrapWithPadding(iconBg || iconWrap);
            const textContent = textBg || textWrap || textNode;
            target.addChild(textContent);

            if (this.options.textPosition.anchor) {
                textContent.setAnchorPoint(this.options.textPosition.anchor);
            }
            textContent.setAlignment(this.options.textPosition);

            target = cleverapps.UI.wrap(target);
        } else {
            target = new cleverapps.Layout([iconBg || iconWrap, textBg || textWrap || textNode], {
                direction: this.options.textDirection !== undefined ? this.options.textDirection : cleverapps.UI.VERTICAL,
                margin: this.options.textMargin !== undefined ? this.options.textMargin : styles.textMargin
            });
        }

        target.icon = icon;
        target.text = textNode;
        target.textBg = textBg;
        target.reward = reward;

        if (this.options.shine) {
            target.shine = StandartAnimations.rays(
                iconWrap,
                typeof this.options.shine === "object" ? this.options.shine : undefined
            );
        }

        if (this.options.help && this.helpButtonIsApplicable(reward)) {
            const helpButton = new cleverapps.UI.HelpButton({
                callback: () => this.openRewardHelp(reward)
            });
            helpButton.setLocalZOrder(10);
            (iconBg || iconWrap).addChild(helpButton);
            target.helpButton = helpButton;

            const helpOptions = typeof this.options.help === "object" ? this.options.help : {};
            helpButton.setAlignment(helpOptions.alignment || styles.helpButton.alignment);
            const scale = helpOptions.scale || styles.helpButton.scale;
            if (scale) {
                helpButton.setScale(scale);
                helpButton.baseScale = scale;
            }
        }

        return target;
    },

    helpButtonIsApplicable: function (reward) {
        return reward.type === "units";
    },

    isChestReward: function (reward) {
        if (cleverapps.flags.fixedChests || typeof Chest === "undefined") {
            return false;
        }
        return Families[reward.value.code].type === cleverapps.unitsLibrary.getExpeditionUnitType("chest");
    },

    isCupReward: function (reward) {
        return typeof CupComponent !== "undefined" && CupComponent.IsCup(reward.value);
    },

    openRewardHelp: function (reward) {
        if (this.isChestReward(reward) || this.isCupReward(reward) && ChestPrizeProbWindow !== "undefined") {
            const probs = this.isChestReward(reward) ? Chest.ListPrizeProb(reward.value) : CupComponent.ListPrizeProb(reward.value);

            cleverapps.focusManager.display({
                focus: "ChestPrizeProbHelp",
                stack: true,
                action: function (f) {
                    new ChestPrizeProbWindow(reward.value, probs);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        } else {
            cleverapps.focusManager.display({
                focus: "UnitsLibraryWindow",
                stack: true,
                action: function (f) {
                    if (cleverapps.config.type === "merge2") {
                        new Merge2UnitsLibraryWindow(reward.value);
                    } else {
                        new UnitsLibraryWindow(reward.value);
                    }
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    },

    showUp: function (callback = () => {}, options = {}) {
        const startOffsetY = cleverapps.styles.RewardsListComponent.showUp.startOffsetY;

        if (!this.targets.length) {
            callback();
        }

        const actions = [];
        const source = options.source;

        this.targets.forEach((target, id) => {
            if (target.shine) {
                target.shine.setVisible(false);
            }

            target.setCascadeOpacityEnabledRecursively(true);
            target.setOpacity(0);

            let moveAction, fromPosition;

            if (source) {
                fromPosition = target.parent.convertToNodeSpace(source.parent.convertToWorldSpace(source.getPosition()));

                moveAction = new cc.Spawn(
                    new cc.MoveTo(0.4, target.x, target.y).easing(cc.easeIn(2)),
                    new cc.FadeIn(0.4).easing(cc.easeIn(2))
                );
            } else {
                fromPosition = cc.p(target.x, target.y - startOffsetY);

                moveAction = new cc.Spawn(
                    new cc.MoveBy(0.6, 0, startOffsetY).easing(cc.easeOut(2)),
                    new cc.FadeIn(0.6).easing(cc.easeIn(2))
                );
            }

            target.setAlignment(fromPosition);

            const targetAction = new cc.Sequence(
                moveAction,
                new cc.Sequence(
                    new cc.DelayTime(0.1),
                    new cc.CallFunc(() => {
                        if (target.shine) {
                            target.shine.setVisible(true);
                            target.shine.setAnimationAndIdleAfter("open", "idle");
                        }
                    }),
                    new cc.CallFunc(() => {
                        if (id === this.targets.length - 1) {
                            callback();
                        }
                    })
                )
            );

            actions.push(new cc.Sequence(
                new cc.CallFunc(() => {
                    target.runAction(targetAction);
                }),
                new cc.DelayTime(targetAction.getDuration())
            ));
        });

        this.runAction(new cc.Spawn(actions));
    },

    receiveRewards: function () {
        this.reward.receiveRewards();
    },

    receiveRewardsAction: function (options) {
        options = options || {};

        let actions = [];

        if (!options.noWinEffect) {
            cleverapps.effects.fire("ui.reward.win");
        }

        this.targets.forEach((target, index) => {
            if (target.shine) {
                actions.push(this._shineAction(target));
            }

            if (!options.noFadeOut) {
                if (target.text) {
                    actions.push(this._fadeOutAction(target.textBg || target.text));
                }

                if (target.helpButton) {
                    actions.push(this._fadeOutAction(target.helpButton));
                }
            }

            const collect = function () {
                target.icon.setLocalZOrder(this.targets.length - index);

                const delay = options.delay || 0;
                return target.reward.collectRewardsAction(target.icon, {
                    delay,
                    beginScale: cc.Base.AdjustScaleTo(target.icon, cleverapps.Scenes.GetMovingNode(target.icon)).y,
                    keepSource: !!options.noFadeOut,
                    small: Boolean(this.options.small),
                    effect: RewardTypes[target.reward.type].getCollectRewardEffect && RewardTypes[target.reward.type].getCollectRewardEffect(target.reward.value),
                    flyingAnimation: options.noFlyTypes && options.noFlyTypes.includes(target.reward.type)
                        ? Reward.NO_ANIMATION : options.flyingAnimation,
                    spawnHaptic: options.spawnHaptic,
                    landHaptic: options.landHaptic,
                    collectHaptic: options.collectHaptic
                });
            }.bind(this);

            actions.push(collect());
        });

        actions.push(new cc.Sequence(this.reward.customRewards.map((reward) => reward.collectRewardsAction())));

        actions = new cc.Spawn(actions);

        if (options.callback) {
            actions = new cc.Sequence(actions, new cc.CallFunc(options.callback));
        }

        return actions;
    },

    receiveRewardsAnimation: function (options) {
        const scene = cleverapps.Scenes.GetRunningScene();
        scene.runAction(this.receiveRewardsAction(options));
    },

    _shineAction: function (target) {
        return new cc.CallFunc(() => {
            target.shine.setAnimation(1, "close", false);
        });
    },

    _fadeOutAction: function (node) {
        // fade the bg out with the amount it holds, otherwise it lingers over the collected reward
        node.setCascadeOpacityEnabledRecursively(true);

        const fadeOut = new cc.FadeOut(0.75);

        return new cc.Sequence(
            new cc.CallFunc(() => {
                if (node.isRunning()) {
                    node.runAction(new cc.Sequence(fadeOut, new cc.Hide()));
                }
            }),
            new cc.DelayTime(fadeOut.getDuration())
        );
    },

    calcColumnsCount: function (rewardsCount) {
        if (this.options.calcColumnsCount) {
            return this.options.calcColumnsCount(rewardsCount);
        }

        if (rewardsCount <= 3) {
            return rewardsCount;
        }

        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            return 4;
        }

        if (rewardsCount === 4 && cleverapps.resolution.mode !== cleverapps.WideMode.HORIZONTAL) {
            return 2;
        }

        return 3;
    }
});

cleverapps.styles.RewardsListComponent = {
    helpButton: {
        scale: 0.7,
        alignment: {
            x: { align: "right", dx: 30 },
            y: { align: "top", dy: 30 }
        }
    },
    margin: {
        x: 30,
        y: 30
    },
    shine: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 40 }
    },
    showUp: {
        startOffsetY: 25,
        floatingOffset: 4
    },
    textMargin: 10,
    price: {
        dy: 10
    }
};

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    REWARDS_PRICE_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.YELLOW,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    REWARDS_PRICE_CURRENCY_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.BLACK,
        stroke: cleverapps.styles.DECORATORS.WHITE_STROKE
    }
});
